// Mock data for Mallikarjuna Tours & Travels clone
// NOTE: All data below is MOCKED for the frontend-only teaser.

export const LOGO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_journey-revamp-4/artifacts/6a5h277j_WhatsApp%20Image%202026-08-13%20at%209.50.42%20AM-3.jpeg";

export const BANNERS = [
  {
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_journey-revamp-4/artifacts/2l7c2791_WhatsApp%20Image%202026-08-13%20at%209.50.42%20AM-2.jpeg",
    alt: "Srisailam Shiva Parvati Statues",
  },
  {
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_journey-revamp-4/artifacts/nf7j9wnh_WhatsApp%20Image%202026-08-13%20at%209.50.42%20AM.jpeg",
    alt: "Mallikarjuna Temple Gopuram at Night",
  },
  {
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/OCTOPUS-VIEW-POINT.jpg.webp",
    alt: "Octopus View Point over the Krishna River",
  },
  {
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/srisailam-dam.jpg.webp",
    alt: "Srisailam Dam across River Krishna",
  },
  {
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/Patala_Ganga-srisailam.jpg.webp",
    alt: "Pathala Ganga on the holy Krishna River",
  },
];

export const CONTACT = {
  primary: "8247019130", // used for Call + WhatsApp
  secondary: "7396789165",
  whatsapp: "918247019130",
  address: "4-7-6/27, AP Colony, Nacharam, Hyderabad 500076",
  email: "info@mallikarjunatours.in",
};

export const NAV_LINKS = [
  { label: "Home", to: "home" },
  { label: "Packages", to: "packages" },
  { label: "Places", to: "places" },
  { label: "Our Fleet", to: "fleet" },
  { label: "About", to: "about" },
  { label: "Contact", to: "contact" },
];

export const PACKAGES = [
  {
    id: "one-day",
    title: "One Day Tour Package",
    subtitle: "Hyderabad → Srisailam → Hyderabad",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/27.jpg.webp",
    tagline: "Perfect for a quick divine darshan",
    highlights: [
      "Mallikarjuna Temple",
      "Bramaraambika Devi Temple",
      "Saakshi Ganapathi Temple",
      "Paathala Ganga",
      "Srisailam Dam",
      "Hatkeshwar Temple",
      "Octopus View Point",
      "Paaladhara, Panchadhara",
    ],
  },
  {
    id: "two-day",
    title: "Two Days Tour Package",
    subtitle: "Explore Srisailam in depth",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/know-srisailam-temple-andhra-pradesh.jpg.webp",
    tagline: "Cover every sacred & scenic spot",
    highlights: [
      "Mallikarjuna Temple",
      "Bramaraambika Devi Temple",
      "Saakshi Ganapathi Temple",
      "Paathala Ganga",
      "Srisailam Dam",
      "Hatkeshwar Temple",
      "Octopus View Point",
      "Paaladhara, Panchadhara",
      "Sikhareswara Temple",
      "Tiger Reserve Safari",
      "Srisailam Ropeway",
      "Srisailam Boating",
      "Akha Mahadevi Caves",
      "Chenchu Lakshmi Museum",
    ],
  },
];

export const INCLUSIONS = [
  "Cab for round trip from Hyderabad – Srisailam – Hyderabad with 500 Kms limit",
  "State Permit",
  "GST @ 5%",
  "Toll Gate Charges",
  "Parking Charges",
  "Driver Allowance / Batta",
  "Pickup & Drop from your Hotel / Home",
];

export const EXCLUSIONS = [
  "Entry Fee for tourist attractions",
  "Lodging / Accommodation",
  "Breakfast, Lunch or any meal",
  "Guides Payment (guests to arrange on their own)",
  "Multiple pickups / drops (fix one place for pickup & drop)",
  "Extra Charges beyond 500 Kms – starts from ₹14 or more per Km",
];

export const PLACES = [
  {
    name: "Mallikarjuna Swamy Temple",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/mallikarjuna-swamy-temple.jpg.webp",
    desc: "One of the 12 revered Jyotirlingas of Lord Shiva.",
  },
  {
    name: "Bramaramba Devi Temple",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/Srisailam-Bhrmaramba-1.jpg.webp",
    desc: "One of the 18 Maha Shakti Peethas of Goddess Parvati.",
  },
  {
    name: "Sakshi Ganapathi Temple",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/sakshi-ganapathi-TEMPLE.jpeg.webp",
    desc: "The witness deity of pilgrims visiting Srisailam.",
  },
  {
    name: "Sikareswara Temple",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/sikhareswara-swamy-temple.jpg.webp",
    desc: "The highest peak temple offering panoramic views.",
  },
  {
    name: "Akkamahadevi Caves",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/akka-mahadevi-caves-srisailam-1024x512.jpg.webp",
    desc: "Ancient caves reachable by a scenic boat ride.",
  },
  {
    name: "Hatakeswara Temple",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/HATEKESWARAM-SRISAILAM.jpg.webp",
    desc: "A serene temple with rich spiritual heritage.",
  },
  {
    name: "Shivaji Spoorthy Kendram",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/SHIVAJI-SPOORTHY-KENDRAM-1024x576.png.webp",
    desc: "A museum dedicated to Chatrapati Shivaji Maharaj.",
  },
  {
    name: "Srisailam Tiger Reserve",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/Srisailam-Tiger-Reserve-1024x683.jpeg.webp",
    desc: "India's largest tiger reserve amid the Nallamala forest.",
  },
  {
    name: "Srisailam Ropeway",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/srisailam-ropeway-1024x576.jpg.webp",
    desc: "Aerial ropeway ride down to Pathala Ganga.",
  },
  {
    name: "Chenchu Lakshmi Tribal Museum",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/Chenchu-Lakshmi-Tribal-Museum-1-1024x768.jpg.webp",
    desc: "Insights into the tribal culture of the region.",
  },
  {
    name: "Octopus View Point",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/OCTOPUS-VIEW-POINT.jpg.webp",
    desc: "Breathtaking view of the winding Krishna river.",
  },
  {
    name: "Pathala Ganga",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/Patala_Ganga-srisailam.jpg.webp",
    desc: "The holy Krishna river banks for a sacred dip.",
  },
  {
    name: "Srisailam Dam",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/srisailam-dam.jpg.webp",
    desc: "One of the largest dams across river Krishna.",
  },
  {
    name: "Paaladhara Panchadhara",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/paaladhara-panchadhara-1-1024x576.jpg.webp",
    desc: "Natural springs amidst lush green surroundings.",
  },
  {
    name: "Srisailam Boating",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/Srisailam-BOATING.jpg.webp",
    desc: "Enjoy a peaceful boat ride on the Krishna river.",
  },
];

export const FLEET = [
  {
    name: "Maruti Suzuki Swift DZire",
    seats: "4 + 1 Seater",
    type: "Sedan",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/swift-dzire.png.webp",
  },
  {
    name: "Toyota Etios",
    seats: "4 + 1 Seater",
    type: "Sedan",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/toyota-etios.png.webp",
  },
  {
    name: "Maruti Suzuki Ertiga",
    seats: "6 + 1 Seater",
    type: "MUV",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/maruti-suzuki-ertiga-cab.png.webp",
  },
  {
    name: "Toyota Innova",
    seats: "7 + 1 Seater",
    type: "SUV",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/hyderabad-to-srisailam-innova.png.webp",
  },
  {
    name: "Toyota Innova Crysta",
    seats: "7 + 1 Seater",
    type: "Premium SUV",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/innova-crysta-taxi.png.webp",
  },
  {
    name: "Force Tempo Traveller",
    seats: "12 + 1 Seater",
    type: "Van",
    image:
      "https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/tempo-traveller-hyderabad.png.webp",
  },
];

export const FEATURES = [
  { title: "10+ Years Experience", desc: "A trusted name in the Hyderabad cab business." },
  { title: "Well-Maintained Cabs", desc: "Clean, comfortable & sanitised vehicles." },
  { title: "Experienced Drivers", desc: "Courteous drivers who know every route." },
  { title: "Transparent Pricing", desc: "No hidden charges, all-inclusive packages." },
];

export const TESTIMONIALS = [
  {
    name: "Ravi Kumar",
    place: "Hyderabad",
    text: "Wonderful darshan trip to Srisailam. Driver was punctual and the Innova was very clean. Highly recommended!",
    rating: 5,
  },
  {
    name: "Lakshmi Prasad",
    place: "Secunderabad",
    text: "Booked the two-day package for our family. Everything was well organised and pricing was transparent.",
    rating: 5,
  },
  {
    name: "Suresh Reddy",
    place: "Nacharam",
    text: "Very comfortable journey and friendly driver. Will definitely book again for our next pilgrimage.",
    rating: 5,
  },
];

export const POPULAR_PICKUPS = [
  "Ameerpet", "Kukatpally", "Dilsukhnagar", "LB Nagar", "Uppal", "Nacharam",
  "Secunderabad", "Miyapur", "Gachibowli", "Hitech City", "Mehdipatnam", "Kompally",
];
